import type { NoteWrite, StudyNote } from './studyNotesApi';

export function noteStatusWrite(note: StudyNote, status: NoteWrite['status']): NoteWrite {
  return {
    id: note.id,
    request_id: crypto.randomUUID(),
    expected_version: note.version,
    title: note.title,
    body: note.body,
    topic: note.topic,
    subject_key: note.subject_key,
    term_id: note.term_id,
    class_date: note.class_date,
    pages: note.pages,
    linked_artifact_ids: note.linked_artifact_ids,
    linked_task_ids: note.linked_task_ids,
    status,
  };
}
